<template>
    <span class="ah-el-select-cny">
        <el-select
            v-model="inputVal"
            placeholder="請選幣別"
            no-data-text="無資料"
            no-match-text="無相關資料"
            :disabled="disabled"
            :style="`width: ${ width }`"
            class="cny-dropdown"
            :multiple="multiple"
            @change="handleChange"
        >
            <el-option :label="nullLabel" :value="null" v-if="enableNull" :key="null">{{ nullLabel }}</el-option>
            <el-option v-for="item in computedOptions" :key="item.cny" :label="item.cnynam" :value="item.cny" class="cny-dropdown-option" :id="'cny-dropdown-option-' + item.cny">
                <span style="float: left">{{ item.cnynam }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px; margin: 0 15px;">{{ item.cny }}</span>
            </el-option>
        </el-select>
    </span>
</template>
<script>
export default {
    name: 'ah-el-select-cny',
    props: {
        value: {
            type: [String, Array],
            default: 'TWD',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        availables: {
            type: Array,
            default: () => null,
        },
        enableNull: {
            type: Boolean,
            default: false,
        },
        nullLabel: {
            type: String,
            default: '無幣別',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '150px',
        },
    },
    // props: ['value', 'disabled', 'availables', 'enableNull', 'nullLabel', 'multiple'],
    components: {},
    data() {
        return {
            options: [],
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        computedOptions() {
            if (!this.availables) {
                return this.options;
            }
            return this.options.filter((item) => this.availables.includes(item.cny));
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$api({
                url: '/Tool/GetCurrencyOptions',
                method: 'GET',
            }).then((resp) => {
                this.options = resp.data.options;
            });
        },

        handleChange(val) {
            this.$emit('change', val);
        },
    },
};
</script>
<style lang="scss">
.cny-dropdown-option.el-select-dropdown__item::after {
    right: 12px !important;
}
</style>
